
import { defineComponent } from 'vue';
export default defineComponent({
  name: 'Decoration',
  setup() {},
});
